export default "__VITE_ASSET__BXkSUoho__"